import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { dateFormat } from "../../../utils/helper";
import PageTableHeader from "../../components/pageTableHeader/pageTableHeader";
import ContentCard from "../common/profile/contentCard";
import {
  getUserDetail,
  
} from "../../../services/workspace/user.service";
import toast from "react-hot-toast";
import DefaultButton from "../../components/buttons/defaultButton";
import { _userRole } from "../../../utils/common";
import useUserRole from "../../../hooks/useUserRole";
import Loading from "../../components/skeleton/loading";
import { NoDataFound } from "../../components/table/tableComponent";

const items = [
  { label: "Home", path: "/" },
  { label: "View Profile", path: "" },
];

function CommonProfileView() {
  const { id } = useParams();
  const [data, setData] = useState();
  const [personalInfo, setPersonalInfo] = useState([]);
  const [parentInfo, setParentInfo] = useState([]);
  const [addressCard, setAddressCard] = useState([]);
  const [contactCard, setContactCard] = useState([]);
  const [licenseCard, setLicenseCard] = useState([]);
  const [reporting, setReporting] = useState([]);
  const [academicCard, setAcademicCard] = useState([]);
  const [workCard, setWorkCard] = useState([]);
  const [loading, setLoading] = useState(false);

  const assignData = (user) => {
    const personalInfo = [
      {
        label: "Name",
        detail: `${user?.user_info?.first_name || ""} ${
          user?.user_info?.last_name || ""
        }`,
      },
      {
        label: "Date Of Birth",
        detail: user?.user_info?.date_of_birth || user?.user_info?.dob || "-",
      },
      { label: "Gender", detail: user?.user_info?.gender || "-" },
      { label: "Caste", detail: user?.user_info?.caste || "-" },
      { label: "Caste Category", detail: user?.user_info?.caste_category || "-" },
      { label: "Religion", detail: user?.user_info?.religion || "-" },
      { label: "Nationality", detail: user?.user_info?.nationality || "-" },
    ];

    const academicCard = [
      {
        label: "class",
        detail: user?.user_info?.active_class?.class?.name || "-",
      },
      { label: "Roll No.", detail: user?.user_info?.roll_no || "-" },
      {
        label: "Section",
        detail: user?.user_info?.active_class?.section?.name || "-",
      },
      { label: "Admission Number", detail: user?.user_info?.admission_number || "" },
      { label: "Family id", detail: user?.user_info?.family_id || "" },
    ];
    const workCard = [
      {
        label: "Department",
        detail: user?.user_info?.designation?.department?.name || "-",
      },
      {
        label: "degination",
        detail: user?.user_info?.designation?.name || "-",
      },
    ];

    const contactCard = [
      { label: "Contact No.", detail: user?.phone || "" },
      { label: "Email", detail: user?.email || "" },
    ];

    setPersonalInfo(personalInfo);
    setParentInfo(parentInfo);
    setLicenseCard(licenseCard);
    setAddressCard(addressCard);
    setReporting(reporting);
    setContactCard(contactCard);
    setAcademicCard(academicCard);
    setWorkCard(workCard);
  };

  const fetchData = () => {
    setLoading(true);
    getUserDetail(id)
      .then((response) => {
        setLoading(false);
        assignData(response);
        setData(response);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching user detail:", error);
        if (error.response?.status === 404) {
          toast.error("User not found.");
        } else {
          toast.error("Failed to fetch user data.");
        }
      });
  };

  useEffect(() => {
    if (!id) return;
    fetchData();
  }, [id]);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-col gap-2 min-w-[400px] overflow-auto">
        <PageTableHeader
          breadcrumbs={items}
          isSearch={false}
          isFilter={false}
          buttons={
            <div>
               {/* <DefaultButton name={"Edit"} /> */}
            </div>
          }
        />
        {loading ? (
          <Loading />
        ) : 
        data ? (
          <div className="grid md:grid-cols-2 gap-2 p-4 bg-white">
            <div className="flex flex-col gap-2">
              {personalInfo.length > 0 && (
                <ContentCard title="Personal Information" data={personalInfo} />
              )}
              {parentInfo.length > 0 && (
                <ContentCard
                  title="Parent/Guardian Information"
                  data={parentInfo}
                />
              )}
            </div>

            <div className="flex flex-col gap-2">
              {data?.type === 3 ? (
                <ContentCard title="Academic Information" data={academicCard} />
              ) : data?.type === 2 ? (
                <ContentCard title="Work Information" data={workCard} />
              ) : null}
              {contactCard.length > 0 && (
                <ContentCard title="Contact Information" data={contactCard} />
              )}
              {addressCard.length > 0 && (
                <ContentCard title="Address" data={addressCard} />
              )}
            </div>
          </div>
        ) : (
          <div className="bg-white w-full h-full flex items-center justify-center">
            <NoDataFound className={"w-full"} />
          </div>
        )}
      </div>
    </div>
  );
}

export default CommonProfileView;
